export default function rlxMapStyles() {
    return [{
        featureType: 'administrative',
        elementType: 'all',
        stylers: [{
            visibility: 'off',
        }],
    }, {
        featureType: 'administrative',
        elementType: 'labels',
        stylers: [{
            visibility: 'on',
        }],
    }, {
        featureType: 'administrative',
        elementType: 'labels.text.fill',
        stylers: [{
            color: '#6e6c6c',
        }],
    }, {
        featureType: 'administrative.country',
        elementType: 'geometry',
        stylers: [{
            weight: '0.85',
        }, {
            lightness: '45',
        }, {
            visibility: 'on',
        }],
    }, {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [{
            color: '#f2f2f2',
        }],
    }, {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [{
            gamma: '1.09',
        }, {
            lightness: '19',
        }],
    }, {
        featureType: 'landscape',
        elementType: 'labels',
        stylers: [{
            visibility: 'on',
        }, {
            lightness: '-21',
        }, {
            weight: '0.01',
        }],
    }, {
        featureType: 'landscape.natural.landcover',
        elementType: 'geometry',
        stylers: [{
            saturation: '8',
        }, {
            lightness: '8',
        }],
    }, {
        featureType: 'landscape.natural.landcover',
        elementType: 'geometry.fill',
        stylers: [{
            lightness: '6',
        }],
    }, {
        featureType: 'poi',
        elementType: 'all',
        stylers: [{
            visibility: 'off',
        }, {
            saturation: '1',
        }, {
            color: '#cfe1d3',
        }],
    }, {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{
            visibility: 'off',
        }],
    }, {
        featureType: 'poi.attraction',
        elementType: 'labels',
        stylers: [{
            visibility: 'off',
        }],
    }, {
        featureType: 'poi.medical',
        elementType: 'geometry.fill',
        stylers: [{
            visibility: 'off',
        }],
    }, {
        featureType: 'poi.medical',
        elementType: 'geometry.stroke',
        stylers: [{
            visibility: 'on',
        }],
    }, {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{
            visibility: 'on',
        }, {
            color: '#cfe1d3',
        }],
    }, {
        featureType: 'road',
        elementType: 'all',
        stylers: [{
            saturation: '-100',
        }, {
            lightness: '45',
        }],
    }, {
        featureType: 'road',
        elementType: 'geometry.fill',
        stylers: [{
            visibility: 'on',
        }],
    }, {
        featureType: 'road.highway',
        elementType: 'all',
        stylers: [{
            visibility: 'on',
        }],
    }, {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{
            visibility: 'on',
        }, {
            color: '#dcdfe2',
        }],
    }, {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [{
            visibility: 'on',
        }],
    }, {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{
            visibility: 'off',
        }],
    }, {
        featureType: 'road.highway',
        elementType: 'labels.icon',
        stylers: [{
            visibility: 'off',
        }],
    }, {
        featureType: 'road.highway.controlled_access',
        elementType: 'geometry',
        stylers: [{
            visibility: 'off',
        }],
    }, {
        featureType: 'road.highway.controlled_access',
        elementType: 'geometry.stroke',
        stylers: [{
            visibility: 'on',
        }],
    }, {
        featureType: 'road.highway.controlled_access',
        elementType: 'labels',
        stylers: [{
            visibility: 'off',
        }],
    }, {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [{
            visibility: 'on',
        }],
    }, {
        featureType: 'road.arterial',
        elementType: 'labels.icon',
        stylers: [{
            visibility: 'off',
        }],
    }, {
        featureType: 'road.local',
        elementType: 'all',
        stylers: [{
            visibility: 'on',
        }],
    }, {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [{
            visibility: 'on',
        }],
    }, {
        featureType: 'road.local',
        elementType: 'geometry.fill',
        stylers: [{
            visibility: 'on',
        }],
    }, {
        featureType: 'road.local',
        elementType: 'labels',
        stylers: [{
            visibility: 'on',
        }],
    }, {
        featureType: 'transit',
        elementType: 'all',
        stylers: [{
            visibility: 'off',
        }],
    }, {
        featureType: 'transit',
        elementType: 'geometry.fill',
        stylers: [{
            visibility: 'on',
        }],
    }, {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [{
            visibility: 'off',
        }],
    }, {
        featureType: 'transit.station',
        elementType: 'all',
        stylers: [{
            visibility: 'on',
        }],
    }, {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [{
            gamma: '1.57',
        }, {
            lightness: '-10',
        }],
    }, {
        featureType: 'transit.station',
        elementType: 'labels',
        stylers: [{
            weight: '0.01',
        }, {
            visibility: 'on',
        }, {
            saturation: '-100',
        }, {
            lightness: '-3',
        }],
    }, {
        featureType: 'transit.station',
        elementType: 'labels.icon',
        stylers: [{
            weight: '0.01',
        }],
    }, {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{
            color: '#c2d8e1',
        }],
    }, {
        featureType: 'water',
        elementType: 'labels.text',
        stylers: [{
            visibility: 'on',
        }, {
            color: '#b0bdc7',
        }],
    }];
}
